import React from 'react';
import ReactModal from 'react-modal'
import PropTypes from 'prop-types'
import FlashMessage from '../containers/flash-message'
import USD from './usd'
import debounce from 'lodash.debounce'

const SelectPaymentModal = props => {
  const debouncedTypeSelected = debounce(props.onPaymentTypeSelected, 200)

  return (
    <ReactModal isOpen={props.isOpen} style={props.style}
      onRequestClose={props.onRequestClose} contentLabel='Select Payment Modal'>
      <FlashMessage />
      <div className='payment-type-selector'>
        <div className='payment-type-selector__item'
          onClick={() => props.onPaymentTypeSelected('MANUAL_CARD')}>
          <div className='payment-type-selector__image'><img src='/shop/manual.png'/></div>
          <span className='payment-type-selector__title'>Manual Input</span>
        </div>
        {props.onClickOpenOrder &&
          <div className='payment-type-selector__item'
            onClick={props.onClickOpenOrder}>
            <div className='payment-type-selector__image'>
              <img style={{maxWidth: '24px', maxHeight: '24px'}} src='/shop/open-order.png'/>
            </div>
            <span className='payment-type-selector__title payment-type-selector__title--open-order'>Open Tab</span>
          </div>
        }
        <div className='payment-type-selector__item'
          onClick={() => debouncedTypeSelected('CASH')}>
          <div className='payment-type-selector__image'><img src='/shop/green-cash.png'/></div>
          <span className='payment-type-selector__title payment-type-selector__title--cash'>
            Cash
            <br/>
            {window.App.config.showPriceInPaymentSelector && typeof(props.cashAmount) != 'undefined' &&
              <USD className='payment-type-selector__amount' val={props.cashAmount}/>}
          </span>
        </div>
        {props.zellePayments &&
          <div className='payment-type-selector__item'
            onClick={() => debouncedTypeSelected('ZELLE')}>
            <div className='payment-type-selector__image'><img src='/shop/zelle.png'/></div>
            <span className='payment-type-selector__title payment-type-selector__title--zelle'>
              Zelle
            </span>
          </div>
        }
        {props.showTouchless &&
          <div className='payment-type-selector__item'
            onClick={() => debouncedTypeSelected('TOUCHLESS')}>
            <div className='payment-type-selector__image'><img src='/shop/touchless.png'/></div>
            <span className='payment-type-selector__title payment-type-selector__title--touchless'>
              Touchless
            </span>
          </div>
        }
        {props.showTerminal &&
          <div className='payment-type-selector__item'
            onClick={() => props.onPaymentTypeSelected('TERMINAL')}>
            <div className='payment-type-selector__image'><img src='/shop/terminal.png'/></div>
            <span className='payment-type-selector__title payment-type-selector__title--terminal'>
              BBPOS Terminal
            </span>
          </div>
        }
        {props.showM2 &&
          <div className='payment-type-selector__item'
            onClick={() => props.onPaymentTypeSelected('M2_TERMINAL')}>
            <div className='payment-type-selector__image'><img src='/shop/nfc.png'/></div>
            <span className='payment-type-selector__title payment-type-selector__title--terminal'>
              M2 Terminal
            </span>
          </div>
        }
      </div>
    </ReactModal>
  )
}

SelectPaymentModal.propTypes = {
  isOpen: PropTypes.bool,
  showTouchless: PropTypes.bool,
  showTerminal: PropTypes.bool,
  showM2: PropTypes.bool,
  onClickOpenOrder: PropTypes.func,
  onPaymentTypeSelected: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired
}

export default SelectPaymentModal
